import { useEffect } from 'react';

import { isFontsLoadedAtom, useSetValue } from '@/store';

import BentonSansBlack from '@/assets/fonts/BentonSans-Black.otf';
import BentonSansBold from '@/assets/fonts/BentonSans-Bold.otf';
import BentonSansMedium from '@/assets/fonts/BentonSans-Medium.otf';
import BentonSansRegular from '@/assets/fonts/BentonSans-Regular.otf';

const fonts = [
  {
    family: 'Benton Sans',
    url: BentonSansRegular,
    options: { weight: '400', style: 'normal' },
  },
  {
    family: 'Benton Sans',
    url: BentonSansMedium,
    options: { weight: '500' },
  },
  {
    family: 'Benton Sans',
    url: BentonSansBold,
    options: { weight: '700' },
  },
  {
    family: 'Benton Sans',
    url: BentonSansBlack,
    options: { weight: '900' },
  },
];

export const FontLoader = () => {
  const setIsFontsLoaded = useSetValue(isFontsLoadedAtom);

  useEffect(() => {
    (async () => {
      try {
        const fontPromises = fonts.map(async ({ family, url, options = {} }) => {
          const font = new FontFace(family, `url(${url})`, options);
          await font.load();
          document.fonts.add(font);
          return font;
        });

        await Promise.all(fontPromises);
        setIsFontsLoaded(true);
      } catch (err) {
        console.error('Font loading failed:', err);
      }
    })();
  }, [setIsFontsLoaded]);

  return null;
};
